export type DesignerRuntime = {
  basePath: '/roofing-designer' | '/solar-designer';
  designVertical: 'roofing' | 'solar';
};

export type EmbeddedDesignerRuntime = {
  apiBaseUrl: string;
  designVertical: DesignerRuntime['designVertical'];
  search: string;
  sessionToken: string | null;
  onNavigate: (url: string, options?: { replace?: boolean }) => void;
};

let embeddedRuntime: EmbeddedDesignerRuntime | null = null;

const ROOFING_RUNTIME: DesignerRuntime = {
  basePath: '/roofing-designer',
  designVertical: 'roofing'
};

const SOLAR_RUNTIME: DesignerRuntime = {
  basePath: '/solar-designer',
  designVertical: 'solar'
};

export function resolveDesignerRuntime(
  pathname = typeof window !== 'undefined' ? window.location.pathname : ''
): DesignerRuntime {
  if (embeddedRuntime) {
    return embeddedRuntime.designVertical === 'solar'
      ? SOLAR_RUNTIME
      : ROOFING_RUNTIME;
  }
  if (
    pathname === SOLAR_RUNTIME.basePath ||
    pathname.startsWith(`${SOLAR_RUNTIME.basePath}/`)
  ) {
    return SOLAR_RUNTIME;
  }

  return ROOFING_RUNTIME;
}

export function configureEmbeddedDesignerRuntime(
  runtime: EmbeddedDesignerRuntime
): void {
  embeddedRuntime = {
    ...runtime,
    apiBaseUrl: runtime.apiBaseUrl.replace(/\/$/, ''),
    search: runtime.search.startsWith('?')
      ? runtime.search
      : runtime.search
        ? `?${runtime.search}`
        : ''
  };
}

export function clearEmbeddedDesignerRuntime(): void {
  embeddedRuntime = null;
}

export function isEmbeddedDesignerRuntime(): boolean {
  return embeddedRuntime !== null;
}

export function getDesignerApiBaseUrl(): string {
  return (
    embeddedRuntime?.apiBaseUrl ||
    process.env.NX_PUBLIC_API_BASE_URL ||
    ''
  ).replace(/\/$/, '');
}

export function getDesignerRuntimeSearch(): string {
  return embeddedRuntime
    ? embeddedRuntime.search
    : typeof window !== 'undefined'
      ? window.location.search
      : '';
}

export function getEmbeddedDesignerSessionToken(): string | null | undefined {
  return embeddedRuntime?.sessionToken;
}

export function setEmbeddedDesignerSessionToken(token: string | null): void {
  if (embeddedRuntime) embeddedRuntime.sessionToken = token;
}

export function navigateDesignerRuntime(
  url: string,
  options?: { replace?: boolean }
): void {
  if (embeddedRuntime) {
    const parsed = new URL(
      url,
      typeof window !== 'undefined'
        ? window.location.origin
        : 'https://designer.invalid'
    );
    embeddedRuntime.search = parsed.search;
    embeddedRuntime.onNavigate(parsed.toString(), options);
    return;
  }
  if (typeof window === 'undefined') return;
  if (options?.replace) window.location.replace(url);
  else window.location.assign(url);
}

export function updateDesignerRuntimeBaseHref(
  runtime = resolveDesignerRuntime()
): void {
  if (typeof document === 'undefined') return;
  document.querySelector('base')?.setAttribute('href', `${runtime.basePath}/`);
}
